@if (!initiative && initiativeLoading) {
  <div class="row">
    <span class="ag-icon ag-icon-loading" role="presentation" unselectable="on"></span>
  </div>
} @else {
  <div class="row">
    <!-- LEFT SIDE -->
    <div class="col-5 sheet">
      <nb-card>
        <nb-card-body>
          <div class="info-label row">
            <div class="sheet-tag col-12">
              {{ 'Initiative-sheet' | translate}}
            </div>
          </div>
        </nb-card-body>
        <nb-card-body class="p-0">
          <nb-list>

            <!-- ACTION LABEL -->
            <nb-list-item class="left-info">
              <div class="name w-50">
                {{ 'Action label' | translate }}
              </div>
              <div class="value w-50">
                {{ initiative.label }}
              </div>
            </nb-list-item>

            <!-- PERIMETER -->
            <nb-list-item class="left-info">
              <div class="name w-50">
                {{ "pages.energy.initiative.labels.perimeter" | translate }}
              </div>
              @if (initiative.site || initiative.perimeter) {
                <div class="value w-50">
                  @if (initiative.site) {
                    <span>{{ initiative.site.name }}</span>
                  }
                  @if (initiative.site && initiative.perimeter) {
                    <span> > </span>
                  }
                  @if (initiative.perimeter) {
                    <span>{{ initiative.perimeter.name }}</span>
                  }
                </div>
              } @else {
                <div class="value w-50">
                  -
                </div>
              }
            </nb-list-item>

            <!-- STATUS -->
            <nb-list-item class="left-info">
              <div class="name w-50">
                {{ 'Status' | translate }}
              </div>
              @if (initiative.status) {
                <div class="value w-50">
                  {{ initiative.status.name || '-' }}
                </div>
              } @else {
                <div class="value w-50">
                  -
                </div>
              }
            </nb-list-item>

            <!-- EXPECTED DATE -->
            <nb-list-item class="left-info">
              <div class="name w-50">
                {{ 'Planned date of action' | translate }}
              </div>
              <div class="value w-50">
                {{ initiative.savings_start_at | date:'MMMM y' | titlecase }}
              </div>
            </nb-list-item>

            <!-- REAL DATE -->
            <nb-list-item class="left-info">
              <div class="name w-50">
                {{ 'Real date' | translate }}
              </div>
              <div class="value w-50">
                -
              </div>
            </nb-list-item>

            <!-- QUANTITY -->
            @if (initiative.quantity && initiative.quantity !== 0) {
              <nb-list-item class="left-info">
                <div class="name w-50">
                  {{ 'Quantity' | translate }}
                </div>
                <div class="value w-50">
                  {{ initiative.quantity }}
                </div>
              </nb-list-item>
            }

            <!-- QUANTITY COST -->
            <nb-list-item class="left-info">
              <div class="name w-50">
                {{ 'Unit cost' | translate }}
              </div>
              <div class="value w-50">
                @if (initiative.budget) {
                  {{ getUnitCost() | ngxCurrency:currency }} {{ "/u" | translate }}
                } @else { - }
              </div>
            </nb-list-item>

            <!-- ACTION TYPE -->
            <nb-list-item class="left-info">
              <div class="name w-50">
                {{ 'Fidji ACT nomenclature' | translate }}
              </div>
              <div class="value w-50">
                {{ initiative.initiative_type.id | initiativeType }}
              </div>
            </nb-list-item>

            <!-- RESPONSIBLE -->
            <nb-list-item class="left-info">
              <div class="name w-50">
                {{ 'Responsible' | translate }}
              </div>
              <div class="value w-50">
                {{ initiative.responsible ? (initiative.responsible | ngxUsername) : '-' }}
              </div>
            </nb-list-item>
          </nb-list>
          <!-- SEE MORE -->
          <nb-accordion>
            <nb-accordion-item (collapsedChange)="seeMoreOpened = !$event">
              <nb-accordion-item-header>
                @if (seeMoreOpened) {
                  <span>{{ 'See less' | translate }}</span>
                } @else {
                  <span>{{ 'See more' | translate }}</span>
                }
              </nb-accordion-item-header>
              <nb-accordion-item-body>
                <nb-list>
                  <!-- CONFIDENCE ON FEASIBILITY -->
                  <nb-list-item class="left-info border-top-none">
                    <div class="name w-50">
                      {{ 'Ease of install' | translate }}
                    </div>
                    <div class="value w-50">
                      {{ initiative.confidence_on_feasibility_name || '-' }}
                    </div>
                  </nb-list-item>

                  <!-- CEE BONUS -->
                  <nb-list-item class="left-info border-top-none">
                    <div class="name w-50">
                      {{ 'Bonus (in {currency}) the year following the action' | translate: { currency: currency } }}
                    </div>
                    <div class="value w-50">
                      {{ initiative.cee_bonus | ngxCurrency:currency }}
                    </div>
                  </nb-list-item>

                  <!-- OTHER RECURRING GAIN -->
                  <nb-list-item class="left-info border-top-none">
                    <div class="name w-50">
                      {{ 'Other recurring gain linked to the action (in {currency} / year)' | translate: { currency: currency } }}
                    </div>
                    <div class="value w-50">
                      {{ initiative.yearly_cost_savings | ngxCurrency:currency }}
                    </div>
                  </nb-list-item>

                  <!-- ACTION CODE -->
                  <nb-list-item class="left-info border-top-none">
                    <div class="name w-50">
                      {{ 'Action code' | translate }}
                    </div>
                    <div class="value w-50">
                      {{ initiative.code || '-' }}
                    </div>
                  </nb-list-item>

                  <!-- ACTION CODE -->
                  <nb-list-item class="left-info border-top-none">
                    <div class="name w-50">
                      {{ 'Initially proposed by' | translate }}
                    </div>
                    <div class="value w-50">
                      {{ initiative.initially_proposed_by || '-' }}
                    </div>
                  </nb-list-item>

                </nb-list>
              </nb-accordion-item-body>
            </nb-accordion-item>
          </nb-accordion>
        </nb-card-body>
      </nb-card>
      <!-- LINKED INVESTMENT -->
      @if (initiative.investment) {
        <div class="macaron invest">
          <span class="macaron-link" (click)="seeInvest(initiative.investment.id)">
            {{ "1 investment related to the action" | translate }} {{ "in" | translate }} {{ initiative.investment.final_schedule }}
          </span>
          <span class="invest-budget">
            {{ budget }}
          </span>
        </div>
      }
      <!-- LINKED ASSETS -->
      @if (initiative.assets.length) {
        <div class="macaron asset">
          <span class="macaron-link" (click)="seeAssets(initiative.assets)">
            {{ "{assetNb} linked asset" | translate : {assetNb : initiative.assets.length} }}
          </span>
          @if (initiative.assets.length === 1) {
            <span class="asset-state">
              {{ technicalStateLabel }}
            </span>
          }
        </div>
      }
      <!-- LINKED DOCUMENTS -->
      @if (docCount > 0) {
        <div class="macaron doc">
          <span class="macaron-link" (click)="seeDocuments()">
            {{ "{count} linked documents" | translate: {count: docCount} }}
          </span>
        </div>
      }
      <!-- Initiative kWh savings VS Site consumptions -->
      @if (getInitiativeSavings() !== 0) {
        <app-site-initiative-consumptions-chart [initiative]="initiative">
        </app-site-initiative-consumptions-chart>
      }
      <!-- PICTURES -->
      @if (settings.dynamicEl?.length) {
        <nb-card class="info">
          <nb-card-body class="p-0 pictures-container">
            <div class="p-0 main-image" [ngStyle]="{ 'background-image': 'url(' + settings.dynamicEl[0].src + ')' }">
              <lightgallery [settings]="settings" [onInit]="onInit"></lightgallery>
              <button
                nbButton
                class="see-photos"
                status="primary"
                (click)="openGallery()"
              >
                {{ 'theme.see-pictures' | translate }} ({{ settings.dynamicEl.length }})
              </button>
            </div>
          </nb-card-body>
        </nb-card>
      }
    </div>
    <!-- RIGHT SIDE -->
    <div class="col-7">
      @if (initiative.gains?.length) {
        <!-- INITIATIVE GAINS LIST -->
        <div class="row">
          <div class="col-12">
            <app-initiative-gains-list
              [initiativeGains]="initiative.gains"
              [gainType]="initiative.initiative_type?.gain_type"
            ></app-initiative-gains-list>
          </div>
        </div>
      }

      <div class="row">
        <div class="col-12">
          <nb-card class="basic-card">
            <nb-card-header>
              {{ "Descriptive" | translate }}
            </nb-card-header>
            <nb-card-body>
              {{ initiative.description || '-' }}
            </nb-card-body>
          </nb-card>
        </div>
      </div>

      @if (initiative.gains?.length) {
        <!-- INITIATIVE TRAJECTORY CHART -->
        <div class="row">
          <div class="col-12">
            <app-initiative-trajectory-chart [initiative]="initiative" [boxShadow]="true"></app-initiative-trajectory-chart>
          </div>
        </div>
      }

      <!-- INITIATIVE CASH FLOW CHART -->
       <!--
       @if (getInitiativeSavings() !== 0 && initiative.investment) {
         <div class="row">
             <div class="col-lg-12" [class]="isPaybackVisible ? '' : 'hidden'">
               <app-initiative-cash-flow-chart
                 [initiative]="initiative"
                 [boxShadow]="true"
                 (isVisible)="isPaybackVisible = $event"
               ></app-initiative-cash-flow-chart>
             </div>
         </div>
       }
       -->
    </div>
  </div>
}
